import { render, staticRenderFns } from "./ProfissoesCBO.vue?vue&type=template&id=dcaf5d92&"
import script from "./ProfissoesCBO.vue?vue&type=script&lang=js&"
export * from "./ProfissoesCBO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports